module.exports = __webpack_public_path__ + "static/img/9.06557b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/zh/9.png
// module id = E20G
// module chunks = 0